import { ContactModel } from "@/apidtos";
import { useGeography } from "@core/hooks/geographyHooks";
import { useEffect } from "react";
import { FieldValues, Form, FormProvider, useForm } from "react-hook-form";
import { Button } from "@core/components/ui/button";
import { useTranslation } from "react-i18next";
import { AddressFormInputs } from "@core/components/forms/Address/AddressFormInputs";

export interface AddressFormProps {
  id?: string;
  onSubmit: (data: ContactModel) => void;
  contact?: ContactModel;
  showSaveButton?: boolean;
}

export const AddressForm = ({ id, onSubmit, contact, showSaveButton }: AddressFormProps) => {
  const { loading, data } = useGeography();
  const { t } = useTranslation();

  const form = useForm<FieldValues>({
    mode: "onChange",
    reValidateMode: "onChange",
    shouldUnregister: false,
    defaultValues: {
      Street1: contact?.Street1 ?? "",
      Street2: contact?.Street2 ?? "",
      Street3: contact?.Street3 ?? "",
      Email: contact?.Email ?? "",
      PhoneNumber: contact?.PhoneNumber ?? "",
      City: contact?.City ?? "",
      RegionId: contact?.RegionId ?? undefined,
      PostalCode: contact?.PostalCode ?? "",
      CountryId: contact?.CountryId ?? undefined,
      DisplayName: contact?.DisplayName ?? "",
      Instructions: contact?.Instructions ?? "",
      ShadowData: contact?.ShadowData ?? {}
    }
  });

  // Set the default country once data is loaded
  useEffect(() => {
    if (!loading && data.countries?.Results?.length && !form.getValues("CountryId") && !contact?.CountryId) {
      form.setValue("CountryId", data.countries.Results[0].Id);
    }
  }, [loading, data.countries, form, contact]);

  const onFormSubmit = (data: ContactModel) => {
    onSubmit(data);
  };

  if (loading || !data.regions || !data.countries) {
    return <div className="flex items-center justify-center p-8">{t("ui.loading", "Loading")}...</div>;
  }

  return (
    <FormProvider {...form}>
      <Form id={id} onSubmit={({ data }) => onFormSubmit(data as ContactModel)}>
        <AddressFormInputs
          regions={data.regions.Results}
          countries={data.countries.Results} />
        {showSaveButton && <Button className="mt-3" type="submit">{t("ui.admin.common.Save", "Save")}</Button>}
      </Form>
    </FormProvider>
  );
};
